import { Waves } from "lucide-react";

export const authInputCls = "w-full min-h-[52px] rounded-xl border border-sand bg-white px-4 text-base text-navy focus:border-gold focus:ring-2 focus:ring-gold/30 outline-none transition";
export const authButtonCls = "w-full min-h-[56px] rounded-full bg-navy hover:bg-navy-light text-cream font-extrabold text-sm tracking-widest transition-colors disabled:opacity-60";
export const authLabelCls = "block text-sm font-bold text-navy mb-1.5";

export function AuthMessage({ tone = "error", testid, children }) {
  const cls = tone === "success"
    ? "text-[#15803D] bg-[#ECFDF3] border-[#BBE5C8]"
    : "text-[#B45309] bg-[#FDF3E3] border-sand";
  return (
    <p role={tone === "error" ? "alert" : "status"} className={`text-sm font-semibold border rounded-xl px-4 py-3 ${cls}`} data-testid={testid}>
      {children}
    </p>
  );
}

export function AuthCard({ title, subtitle, children, testid }) {
  return (
    <div className="min-h-screen bg-navy hero-grain relative flex items-center justify-center px-5 py-10">
      <div className="absolute inset-0 gold-glow" />
      <div className="relative w-full max-w-md bg-cream rounded-3xl border border-sand shadow-2xl p-8 sm:p-10" data-testid={testid}>
        <div className="flex items-center gap-2.5 mb-8">
          <span className="w-10 h-10 rounded-full bg-gold flex items-center justify-center">
            <Waves className="w-5 h-5 text-navy" strokeWidth={2.4} />
          </span>
          <div className="leading-none">
            <p className="font-serif text-2xl font-semibold text-navy">Legacy Wave</p>
            <p className="text-[10px] tracking-[0.3em] uppercase text-gold font-bold">Admin</p>
          </div>
        </div>
        {title && <h1 className="font-serif text-2xl font-semibold text-navy mb-1.5">{title}</h1>}
        {subtitle && <p className="text-sm text-slate-600 mb-6">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}
